import { MdArrowBackIosNew } from "react-icons/md";
import { format } from "date-fns";
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../Providers/AuthProvider';


const OfferRequestHeaderSection = ({ mode }) => {
    const navigate = useNavigate()
    const { authState } = useAuth()

    const getHeaderText = () => {
        if (mode == '1') {
            return 'Oferta dla klienta'
        }
        else {
            if (authState.user && authState.user.isOperator && authState.selectedCustomerData.name) {
                return `Oferta dla ${authState.selectedCustomerData.name}`
            }
            else {
                return `Zapytanie ofertowe ${format(Date.now(), "dd/MM/yyyy")}`
            }
        }
    }

    return (<>
        <div className="col-9">
            <div className="row">
                <div className="col">
                    <h2>{getHeaderText()}</h2>
                </div>
            </div>
        </div>
        <div className="col d-flex align-items-center justify-content-end element-pointer" onClick={() => navigate(-1)}>
            <MdArrowBackIosNew size={25} />
            <span>Wróć</span>
        </div>
    </>)
}

export default OfferRequestHeaderSection